import { render, staticRenderFns } from "./Multiview.vue?vue&type=template&id=9beb4f96&"
import script from "./Multiview.vue?vue&type=script&lang=js&"
export * from "./Multiview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports